import { parameters } from '../parameters/motn-ui-action'
import { UiActionEvent } from './ui-action'

export class MotnUiActionEvent extends UiActionEvent {
  parameters = parameters
}
